import Layer from '@arcgis/core/layers/Layer';
import { GISService } from '../gisServicesTypes';
import { ensureLoadedLayerArray, LayerLoader } from './LayerLoader';

/**
 * Load a layer that's not otherwise special
 */
export const defaultLayerLoader: LayerLoader = {
  shouldUseLoader() {
    return true;
  },
  async load(service) {
    const url = service.gis_service_url?.toLowerCase() || '';
    const isGeocommLayer = url.includes('geocomm');

    const properties: __esri.LayerFromArcGISServerUrlParams['properties'] = {
      id: service.gisLayerID,
      visible: service.auto_checked || false,
      // Only load OBJECTID for feature identification - reduces memory usage significantly
      // ClickToIdentify queries attributes separately when needed
      outFields: ['OBJECTID'],
      // Request 2x more features per tile - balances fewer HTTP requests vs memory usage
      maxRecordCountFactor: 2,
      // Disable popups to reduce feature metadata queries
      popupEnabled: false,
      // Disable auto-refresh - useGISLayersViewDebounce manages refresh timing
      // to only fetch when view is stationary
      refreshInterval: 0,
    };

    if (!isGeocommLayer) {
      properties.opacity = 0.4;
    }

    return loadWithProperties(service, properties);
  },
};

// This pattern gets reused with different properties for several layer types:
export async function loadWithProperties(
  service: GISService,
  properties: __esri.LayerFromArcGISServerUrlParams['properties'],
) {
  const apiKey = service.token;
  const url = service.gis_service_url;
  const requestUrl = apiKey ? url + `?token=${apiKey}` : url;
  const layer = await Layer.fromArcGISServerUrl({
    url: requestUrl,
    properties: {
      apiKey,
      ...properties,
    },
  });
  await layer.load();

  return ensureLoadedLayerArray(layer);
}
